import styled from "styled-components";

export default styled.div`
  background: white;
  height: calc(var(--vh) * 100);
  overflow: hidden;
  padding: var(--gallery-padding, "120px");
`;
